import React, { Ref } from 'react';

import { observer } from 'mobx-react';
import { List } from 'react-virtualized';
import { RenderedRows } from 'react-virtualized/dist/es/List';
import { DetailColumn } from '@bringg-frontend/monitoring';
import classNames from 'classnames';
import { GroupData, ResponseItem } from '@bringg/types';

import useOrderExplorerStore from '../stores/use-order-explorer-store';
import OrderRow from './order-row';
import useBulkActionsList from '../../shared/hooks/use-bulk-actions';
import GroupRow from './group-row/group-row';
import { isGroupRow } from '../../shared/utils/grouping';
import MainColumnHeader from '../../shared/components/main-column-header/main-column-header';

import styles from './order-list.module.scss';

interface Props {
	registerChild: Ref<List>;
	onRowsRendered: (info: RenderedRows) => void;
	withScroll: boolean;
}

export const ORDERS_LIST_ID = 'orders-list';

const customStyles = { header: styles.routesHeader, group: styles.groupRow };

const OrderList = ({ onRowsRendered, registerChild, withScroll }: Props) => {
	const {
		orderExplorerStore: { currentTableDefinition, isScrolled },
		ordersMapStore,
		selectedTasksStore
	} = useOrderExplorerStore();

	const { flatTableItems, total } = currentTableDefinition;

	const actionsList = useBulkActionsList(selectedTasksStore.selectedTasks);

	const mainColumn = {
		id: ORDERS_LIST_ID,
		Header: (
			<MainColumnHeader
				bulkActionItems={actionsList}
				totalViewItems={ordersMapStore.markersToViewOnMap.size}
				onEyeIconClick={ordersMapStore.reset}
				shouldShowUnselect
			/>
		),
		Cell: OrderRow,
		Group: GroupRow
	};

	return (
		<div className={styles.orderList} data-test-id="orders-list">
			<DetailColumn<ResponseItem, GroupData>
				listRef={registerChild}
				rowData={flatTableItems}
				rowCount={total}
				onRowsRendered={onRowsRendered}
				column={mainColumn}
				customStyles={customStyles}
				data-test-id="orders-list-column"
				withScrollBar={withScroll}
				isGroupFn={isGroupRow}
			/>
			<div className={classNames(styles.shadow, { [styles.scroll]: isScrolled })} />
		</div>
	);
};

export default observer(OrderList);
